import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { Modal } from 'react-bootstrap';
import { Button } from '../Elements';

interface WebcamModalProps {
  onCapture: (file: File) => void;
  disabled?: boolean;
}

const WebcamModal: React.FC<WebcamModalProps> = ({ onCapture, disabled }) => {
  const webcamRef = useRef<Webcam | null>(null);
  const [show, setShow] = useState<boolean>(false);
  const [facingMode, setFacingMode] = useState<'user' | 'environment'>('user');

  const videoConstraints = {
    facingMode: facingMode,
  };

  const base64ToFile = (base64: string, filename: string): File => {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handleCapture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      const file = base64ToFile(imageSrc, 'screenshot.jpg');
      onCapture(file);
      setShow(false);
    }
  };

  const handleCameraFlip = () => {
    setFacingMode((prev) => (prev === 'user' ? 'environment' : 'user'));
  };

  return (
    <>
      <div
        className={`file-upload ${disabled ? 'disabled' : ''}`}
        onClick={() => !disabled && setShow(true)}
      >
        <p>
          Use <span>camera</span> to capture the image and upload
        </p>{' '}
        <p className="m-0"></p>
      </div>

      <Modal
        className="petsked-modal-dialog web-camera-dialog"
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <h2>Take a screenshot</h2>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="camera-feed">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/png"
              videoConstraints={videoConstraints}
            />
            {/* <Button variant="inverse" size="lg" onClick={handleCameraFlip}>
              Flip
            </Button> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="petsked-btn button-no-bg" onClick={() => setShow(false)}>
            Close
          </button>

          <button className="petsked-btn button-dark"  onClick={handleCapture}>
            Capture Screenshot
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WebcamModal;
